import { DataLineage, StandardResolverInterface } from "@/utils/graph/GraphInterface";

export type DataLineageTab = "graph" | "table";

export enum DataLineageViewKind {
  FEATURE = "feature",
  RESOLVER = "resolver",
  COLUMN = "column",
}

export type ResolverWithLineage = StandardResolverInterface & { dataLineage: DataLineage };

export interface FeatureLineageMap {
  [dataSource: string]: {
    [table: string]: {
      [featureFqn: string]: LineageMapEntry;
    };
  };
}

export interface ResolverLineageMap {
  [dataSource: string]: {
    [table: string]: {
      [resolverFqn: string]: LineageColumnsMap;
    };
  };
}

export interface ColumnLineageMap {
  [dataSource: string]: {
    [table: string]: {
      [column: string]: {
        [featureFqn: string]: LineageMapEntry;
      };
    };
  };
}

export interface FeatureDatasourceMap {
  [featureFqn: string]: Array<FeatureDataSourceDetail>;
}
export interface ColumnDatasourceMap {
  [column: string]: Array<FeatureDataSourceDetail>;
}
export interface ResolverDatasourceMap {
  [resolverFqn: string]: Array<FeatureDataSourceDetail>;
}

export interface FeatureDataSourceDetail {
  dataSource: string;
  table: string;
  resolverFqn: string;
  featureFqn: string;
  columns: string[];
}

export interface LineageMapEntry {
  [resolverName: string]: LineageMapValue;
}

export interface LineageMapValue {
  name: string;
  columns: LineageColumnsMap;
}

export interface LineageColumnsMap {
  [featureFqn: string]: string[];
}

export type LineageNodeKind =
  | "datasource"
  | "datasource-table"
  | "datasource-column"
  | "resolver"
  | "feature"
  | "scheduled-query";

export interface LineageGraphNode {
  kind: LineageNodeKind;
  id: string;
  name: string;
  icon?: string;
}
